var _defs, _rect, _rect2, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFbs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 143.54 143.54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#00be40;}.cls-2{fill:#fff;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 143.54,
    height: 143.54,
    rx: 14.78
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 26.17,
    y: 91.56,
    width: 91.33,
    height: 7.26
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M52.23,55.35V48H26.17V82.45h9.11V70.18H50V62.79H35.28V55.35Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M79,64.56c3.65-1.68,5.57-4.34,5.57-7.68,0-5.57-4.14-8.92-11.08-8.92H55.83V82.45H73.67c7.59,0,12.12-3.6,12.12-9.71C85.79,68.8,83.28,65.84,79,64.56ZM64.76,55h7c2.56,0,3.94,1.18,3.94,3.35s-1.38,3.34-3.94,3.34h-7Zm7.63,20.49H64.76V68.6h7.73c2.56,0,4,1.23,4,3.55C76.48,74.32,75.05,75.45,72.39,75.45Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M107.13,61.5,103,60.91c-4.09-.6-5.3-1.6-5.3-3.5s1.6-3.2,5.16-3.2c3.29,0,4.9,1.2,5.67,4.2l8.68-1.11c-1.28-6.79-6.16-10.09-14.1-10.09-8.9,0-14.75,4.45-14.75,11.24,0,5.85,3.55,9.25,10.8,10.25l4.34.6c4.6.65,5.7,1.7,5.7,3.7s-1.7,3.2-5.75,3.2a6.51,6.51,0,0,1-6.54-4.59l-9,1.35c1.47,7,6.8,10.23,15.32,10.23,9.65,0,15.35-4.14,15.35-11.19C118.53,65.85,115,62.65,107.13,61.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFbs);
export default __webpack_public_path__ + "static/media/fbs.041a1d70f08217bf848d959c5e6b08f4.svg";
export { ForwardRef as ReactComponent };